// ============================================
// AUTHENTICATED LAYOUT ROUTE
// ============================================

import { createFileRoute, redirect } from '@tanstack/react-router';
import { UserLayout } from '@/layouts';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context }: { context: any }) => {
    if (!context.auth?.isAuthenticated) {
      throw redirect({ to: '/login' });
    }
  },
  component: UserLayout,
});
